import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { TextField } from '@material-ui/core';
import { StandardTextFieldProps } from '@material-ui/core/TextField';
import { createStyles, withStyles } from '@material-ui/styles';
import React from 'react';

const styles = (theme: JupiterTheme) =>
  createStyles({
    textInput: {
      color: theme.palette.grey[50],
      '&:before': {
        borderColor: theme.palette.grey[300],
      },
      '&:hover:before': {
        borderColor: theme.palette.grey[200] + ' !important',
      },
    },
    textInputLabel: {
      color: theme.palette.grey[200],
    },
    textInputLabelFocused: {
      '&&': {
        color: theme.palette.primary.main,
      },
    },
  });

interface FormTextFieldProps extends StandardTextFieldProps {
  classes: any;
  errorText?: string;
}

const FormTextField = ({
  classes,
  errorText,
  ...props
}: FormTextFieldProps) => (
  <TextField
    error={!!errorText}
    helperText={errorText || ' '}
    InputLabelProps={{
      className: classes.textInputLabel,
      classes: {
        focused: classes.textInputLabelFocused,
      },
    }}
    InputProps={{
      className: classes.textInput,
    }}
    multiline={true}
    {...props}
  />
);

export default withStyles(styles)(FormTextField);
